import { render } from "./OwnerRegister.vue?vue&type=template&id=47abd4e5"
import script from "./OwnerRegister.vue?vue&type=script&lang=js"
export * from "./OwnerRegister.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1770878715/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__